import React, { useState } from 'react';
import logo2026 from '../assets/logo-2026.png';

export default function Navbar() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen((currentState) => !currentState);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <>
      <nav
        className="
          fixed left-0 right-0 top-0 z-50
          flex h-24 items-center justify-between
          bg-[#170D27]
          px-4
          font-['Montserrat'] text-white
          sm:px-8
          md:h-28 md:px-16
        "
      >
        {/* Ліва частина — desktop */}
        <div className="hidden items-center gap-10 lg:flex xl:gap-12">
          <a
            href="#programs"
            className="
              text-lg font-semibold text-white/80
              transition-colors duration-200
              hover:text-[#3DFF80]
            "
          >
            Напрямки
          </a>

          <a
            href="#tickets"
            className="
              text-lg font-semibold text-white/80
              transition-colors duration-200
              hover:text-[#E150A8]
            "
          >
            Реєстрація
          </a>
        </div>

        {/* Кнопка мобільного меню */}
        <button
          type="button"
          onClick={toggleMobileMenu}
          aria-label={
            isMobileMenuOpen ? 'Закрити мобільне меню' : 'Відкрити мобільне меню'
          }
          aria-expanded={isMobileMenuOpen}
          aria-controls="mobile-navigation"
          className="
            relative z-[60]
            flex h-10 w-10 flex-col
            items-center justify-center
            gap-[6px]
            lg:hidden
          "
        >
          <span
            className={`
              block h-[3px] w-7 rounded-full
              bg-[#3DFF80]
              transition-all duration-300
              ${
                isMobileMenuOpen
                  ? 'translate-y-[9px] rotate-45'
                  : ''
              }
            `}
          />

          <span
            className={`
              block h-[3px] w-7 rounded-full
              bg-[#E150A8]
              transition-all duration-300
              ${isMobileMenuOpen ? 'opacity-0' : ''}
            `}
          />

          <span
            className={`
              block h-[3px] w-7 rounded-full
              bg-[#3DFF80]
              transition-all duration-300
              ${
                isMobileMenuOpen
                  ? '-translate-y-[9px] -rotate-45'
                  : ''
              }
            `}
          />
        </button>

        {/* Центральний логотип */}
        <div
          className="
            absolute left-1/2 top-1/2
            -translate-x-1/2 -translate-y-1/2
          "
        >
          <a
            href="#home"
            aria-label="Перейти на початок сторінки"
            className="block"
          >
            <img
              src={logo2026}
              alt="APPS Summer Camp"
              className="
                mx-auto h-14 w-auto object-contain
                md:h-20
              "
            />
          </a>
        </div>

        {/* Права частина — desktop */}
        <div className="hidden items-center gap-8 lg:flex">
          <a
            href="#qa"
            className="
              text-lg font-semibold text-white/80
              transition-colors duration-200
              hover:text-[#E150A8]
            "
          >
            Q&amp;A
          </a>

          <a
            href="https://docs.google.com/forms/d/e/1FAIpQLSfQkgc_5KSuyycJqj_zNFuG2QAfc-0NxZlsBvlbHH1AJAbKMw/viewform?usp=sharing&ouid=113598774127325272104"
            target="_blank"
            rel="noopener noreferrer"
            className="
              rounded-full
              bg-[#3DFF80]
              px-8 py-3
              text-lg font-extrabold text-[#0F081B]
              transition-all duration-200
              hover:-translate-y-1
              hover:bg-[#E150A8]
            "
          >
            Доєднатись
          </a>
        </div>

        {/* Балансування логотипа на мобільних */}
        <div className="h-10 w-10 lg:hidden" />
      </nav>

      {/* Мобільне меню */}
      {isMobileMenuOpen && (
        <div className="fixed inset-0 z-40 lg:hidden">
          <button
            type="button"
            aria-label="Закрити мобільне меню"
            onClick={closeMobileMenu}
            className="
              absolute inset-0
              h-full w-full
              bg-black/60
            "
          />

          <div
            id="mobile-navigation"
            className="
              relative z-10
              w-full
              bg-[#170D27]
              px-6 pb-10 pt-32
              font-['Montserrat']
              shadow-[0_20px_50px_rgba(0,0,0,0.4)]
              sm:px-8
            "
          >
            <div className="flex flex-col">
              <a
                href="#programs"
                onClick={closeMobileMenu}
                className="
                  border-b border-white/10
                  py-5
                  text-xl font-bold text-white
                  transition-colors duration-200
                  hover:text-[#3DFF80]
                "
              >
                Напрямки
              </a>

              <a
                href="#tickets"
                onClick={closeMobileMenu}
                className="
                  border-b border-white/10
                  py-5
                  text-xl font-bold text-white
                  transition-colors duration-200
                  hover:text-[#E150A8]
                "
              >
                Реєстрація
              </a>

              <a
                href="#qa"
                onClick={closeMobileMenu}
                className="
                  border-b border-white/10
                  py-5
                  text-xl font-bold text-white
                  transition-colors duration-200
                  hover:text-[#3DFF80]
                "
              >
                Q&amp;A
              </a>

              <a
                href="https://docs.google.com/forms/d/e/1FAIpQLSfQkgc_5KSuyycJqj_zNFuG2QAfc-0NxZlsBvlbHH1AJAbKMw/viewform?usp=sharing&ouid=113598774127325272104"
                target="_blank"
                rel="noopener noreferrer"
                onClick={closeMobileMenu}
                className="
                  mt-7
                  rounded-full
                  bg-[#3DFF80]
                  px-8 py-4
                  text-center
                  text-lg font-extrabold text-[#0F081B]
                  transition-colors duration-200
                  hover:bg-[#E150A8]
                "
              >
                Доєднатись
              </a>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
